import React, { createContext, useContext } from "react";
import Input from "../components/utils/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputAdornment from "@material-ui/core/InputAdornment";
import DragFile from "../components/utils/DragFile";
import { Typography } from "@material-ui/core";
import { Column } from "../components/utils/MaterialUIComponents";
const FunctionsContext = createContext();

export const useFunctions = () => useContext(FunctionsContext);

const FunctionsContextProvider = ({ children }) => {
  const allInputs = {
    level_1: {
      inputs: [
        { name: "name" },
        { name: "points", type: { name: "number", unit: "Pts." } },
      ],
      images: [
        { name: "icon", type: `image/*` },
        { name: "video", type: `video/*` },
      ],
    },
    level_2: {
      inputs: [
        { name: "name" },
        { name: "points", type: { name: "number", unit: "Pts." } },
      ],
      images: [
        { name: "icon", type: `image/*` },
        { name: "video", type: `video/*` },
      ],
    },
    level_3: {
      inputs: [
        { name: "name" },
        { name: "points", type: { name: "number", unit: "Pts." } },
      ],
      images: [
        { name: "icon", type: `image/*` },
        { name: "video", type: `video/*` },
      ],
    },
  };
  const showTags = (tagRefs = {}, active, required = true) =>
    Object.entries(tagRefs)?.map((el, i) => (
      <Column key={i} lg={6}>
        <label
          htmlFor={el[1].placeholder}
          className="text-capitalize fw-bolder"
        >
          {" "}
          {el[1].placeholder.split("_").join(" ")}{" "}
        </label>
        {console.log(active[el[0]])}
        <Input
          ref={el[1].ref}
          required={required}
          id={el[1].placeholder}
          key={`${Math.floor(Math.random() * 1000)}-min`}
          defaultValue={active[el[0]]}
          placeholder={el[1].placeholder.split("_").join(" ")}
          type={el[1]?.type?.name}
          step=".01"
          InputProps={{
            endAdornment: (
              <InputAdornment
                className="text-capitalize fw-bolder"
                position="end"
              >
                {el[1]?.type?.unit}
              </InputAdornment>
            ),
          }}
        />
      </Column>
    ));
  const showImages = (
    images = [],
    setImages = () => {},
    active = {},
    docRef,
    setdisabled
  ) =>
    images.map((el, i) => (
      <Column key={i} xs={12}>
        <Typography variant="h6" className="text-capitalize fw-bold mt-3">
          {" "}
          {el.name.split("_").join(" ")}{" "}
        </Typography>
        <DragFile
          size={el.size}
          type={el.type}
          setdisabled={setdisabled}
          docRef={docRef}
          name={el.name}
          active={active[el.name]?.map((preview, i) => ({
            ...preview,
            database: true,
            i,
          }))}
          setImages={(images) =>
            setImages((prev) => ({ ...prev, [el.name]: images }))
          }
        />
      </Column>
    ));
  const showSelect = (selects = [], selectValues, setSelects) =>
    selects.map((el, i) => (
      <Column key={i} lg={6}>
        <label htmlFor={el.name} className="text-capitalize fw-bolder">
          {" "}
          {el.name.split("_").join(" ")}{" "}
        </label>
        <div className="field">
          <Select
            displayEmpty
            required
            id={el.name}
            className="field_input text-capitalize"
            value={selectValues[el.name]?.name || ""}
            onChange={(e) =>
              setSelects((n) => ({ ...n, [el.name]: { name: e.target.value } }))
            }
          >
            <MenuItem disabled value="">
              <em className="text-capitalize">
                {el.name.split("_").join(" ")}
              </em>
            </MenuItem>
            {el.options.map((el) => (
              <MenuItem className="text-capitalize" value={el}>
                {" "}
                {el}{" "}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="w-100" />
      </Column>
    ));
  const value = { showImages, showTags, showSelect, allInputs };
  return (
    <FunctionsContext.Provider {...{ value }}>
      {children}
    </FunctionsContext.Provider>
  );
};

export default FunctionsContextProvider;
